import { render } from "./ConfirmDialog.vue?vue&type=template&id=8ac89b86&ts=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=8ac89b86&lang=css"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__